import { z } from "zod";
import { sessionStore } from "../../../lib/store";

// The Discovery preference conversation (ProfilingConversation) mirrors its
// per-turn answers here so a hard reload RESUMES at the furthest turn reached
// (the feed-taste preview) instead of re-asking every question — the React turn
// state is in-memory only and does not survive a reload. Only the thread-display
// summary per turn is kept; the real answers (topic/mesh interests) are already
// persisted server-side on the user. `feed-taste` has no answer (its CTA
// finishes the flow), so it is not tracked — an all-answered store resumes
// straight to it. Cleared once the nudge completes or is snoozed.
const PreferenceConversationSchema = z.object({
  topics: z.string().nullable(),
});

export type PreferenceConversationAnswers = z.infer<
  typeof PreferenceConversationSchema
>;

const initialPreferenceConversation: PreferenceConversationAnswers = {
  topics: null,
};

export const preferenceConversationStore = sessionStore(
  "preference-conversation",
  initialPreferenceConversation,
  PreferenceConversationSchema
);

export function resetPreferenceConversation(): void {
  preferenceConversationStore.set(initialPreferenceConversation);
}
